// extracted by mini-css-extract-plugin
export default {"note":"NotesModal_note__IJOHh","closeButton":"NotesModal_closeButton__rn-7o"};